module.exports = __webpack_public_path__ + "static/media/type-1.9a566126.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/type-1.png
// module id = 1123
// module chunks = 0